import React from 'react'



const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.linkedin.com/in/adityacyan/" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-linkedin"></i>
            </a>



            <a href="https://github.com/adityacyan" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-github-alt"></i>
            </a>
            <a href="https://codolio.com/profile/adityacyan" className="home__social-icon" target="_blank" rel="noreferrer">
                <img src="../../assets/codoliobw.svg" alt="Codolio" />
            </a>

        </div>
    )
}

export default Social